import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Section = ({ title, children }) => (
  <div className="mb-9">
    <h2 className="font-display text-xl font-semibold uppercase tracking-wide text-white">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-white/65">{children}</div>
  </div>
);

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App min-h-screen">
      <Header />

      <main className="container-px mx-auto max-w-4xl pt-32 pb-24">
        <button
          onClick={() => navigate("/")}
          className="glass-btn mb-8 px-4 py-2 text-sm font-medium"
        >
          <ArrowLeft className="h-4 w-4" /> {t.nav.about === "About" ? "Back" : t.nav.about === "Про нас" ? "Назад" : "Powrót"}
        </button>

        <p className="text-xs font-semibold tracking-[0.3em] text-white/50">PSS PERSONNEL Sp. z o.o.</p>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl font-bold uppercase tracking-tight text-white">
          Polityka Prywatności
        </h1>

        <div className="glass-card mt-12 rounded-3xl p-7 sm:p-10">
          <Section title="1. Definicje">
            <p><strong className="text-white/90">Administrator</strong> – PSS PERSONNEL Sp. z o.o. z siedzibą w Olsztynie, Aleja Marszałka Józefa Piłsudskiego 77, 10-449 Olsztyn, Polska, wpisana do rejestru agencji zatrudnienia pod numerem KRAZ: 34330, posiadająca NIP: 8982319255.</p>
            <p><strong className="text-white/90">Dane osobowe</strong> – wszelkie informacje o zidentyfikowanej lub możliwej do zidentyfikowania osobie fizycznej.</p>
            <p><strong className="text-white/90">Przetwarzanie</strong> – operacje wykonywane na danych osobowych, takie jak zbieranie, utrwalanie, przechowywanie, przeglądanie, wykorzystywanie czy usuwanie.</p>
            <p><strong className="text-white/90">RODO</strong> – Rozporządzenie Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych.</p>
            <p><strong className="text-white/90">Strona</strong> – strona internetowa prowadzona przez Administratora.</p>
            <p><strong className="text-white/90">Użytkownik</strong> – każda osoba fizyczna odwiedzająca Stronę lub korzystająca z opisanych usług i funkcjonalności.</p>
          </Section>

          <Section title="2. Cele, podstawy prawne oraz okresy przetwarzania danych">
            <p><strong className="text-white/90">2.1. Korzystanie ze strony internetowej.</strong> Dane (np. adresy IP, pliki cookies) przetwarzane są w celu świadczenia usług drogą elektroniczną oraz dla celów analitycznych i statystycznych. Podstawa prawna: Art. 6 ust. 1 lit. b oraz lit. f RODO.</p>
            <p><strong className="text-white/90">2.2. Realizacja usług agencji pracy i outsourcingu.</strong> Dane przetwarzane w celu realizacji umów z partnerami biznesowymi oraz świadczenia usług agencji pracy tymczasowej i outsourcingu. Podstawa prawna: Art. 6 ust. 1 lit. b RODO.</p>
            <p><strong className="text-white/90">2.3. Formularz kontaktowy i zapytania.</strong> Dane z formularza lub przesłane na adres e-mail / numer telefonu przetwarzane są w celu obsługi zapytania i komunikacji. Podstawa prawna: Art. 6 ust. 1 lit. f RODO.</p>
            <p><strong className="text-white/90">2.4. Procesy rekrutacyjne.</strong> Dokumenty aplikacyjne (np. CV) przetwarzane są w celu przeprowadzenia rekrutacji. Podstawa prawna: Art. 6 ust. 1 lit. b lub lit. a RODO. Okres: czas trwania rekrutacji, a przy zgodzie na przyszłe procesy – nie dłużej niż 2 lata.</p>
          </Section>

          <Section title="3. Pliki cookies oraz podobne technologie">
            <p><strong className="text-white/90">3.1.</strong> Administrator wykorzystuje pliki cookies (sesyjne i trwałe) w celu poprawy jakości usług, weryfikacji sesji, zapamiętania ustawień językowych oraz optymalizacji wydajności Strony.</p>
            <p><strong className="text-white/90">3.2. Google Analytics.</strong> Strona korzysta z narzędzi analitycznych Google Analytics (Google LLC), które gromadzą zanonimizowane dane statystyczne i nie służą do identyfikacji tożsamości Użytkownika.</p>
          </Section>

          <Section title="4. Prawa Użytkownika">
            <p>Każdej osobie przysługuje prawo do: dostępu do danych i otrzymania ich kopii, sprostowania, usunięcia („prawo do bycia zapomnianym”), ograniczenia przetwarzania lub wniesienia sprzeciwu, cofnięcia zgody w dowolnym momencie, a także wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych (PUODO).</p>
          </Section>

          <Section title="5. Kontakt z Administratorem">
            <p>W sprawach związanych z ochroną danych osobowych mogą się Państwo skontaktować:</p>
            <p>Telefonicznie: <a href="tel:+48789478483" className="text-white underline hover:text-white/80">+48 789 478 483</a></p>
            <p>E-mail: <a href="mailto:p.sluzalek@pss-group.pl" className="text-white underline hover:text-white/80">p.sluzalek@pss-group.pl</a></p>
            <p>Listownie: PSS PERSONNEL Sp. z o.o., Aleja Marszałka Józefa Piłsudskiego 77, 10-449 Olsztyn, Polska</p>
          </Section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
